<template>
  <a-row>
    <a-col :span="labelCol">
      <div class="label-title">{{title}}</div>
    </a-col>
    <a-col :span="valueCol">
      <a-form-item v-bind="validate">
        <a-input v-model:value="inputValue" @change="onChange" allowClear :disabled="disabled" :type="type" :placeholder="'请输入' + title" />
        <span v-if="validate" class="must">*</span>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: String
    },

    title: {
      type: String,
      default: '标题'
    },

    labelCol: {
      type: Number,
      default: 4
    },

    valueCol: {
      type: Number,
      default: 16
    },

    validate: {
      type: Object,
      default: () => null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    type: {
      type: String,
      default: 'text'
    }
  },
  emits: ['ok', 'update:value'],
  setup (props, { emit }) {
    const inputValue = ref(props.value)

    watch(props, e => {
      inputValue.value = e.value
    })

    const onChange = e => {
      emit('ok', e.target.value)
      emit('update:value', e.target.value)
    }

    return {
      inputValue,
      onChange
    }
  }
})
</script>

<style lang="less" scoped>
  .must{
    position: absolute;
    top: 3px;
    right: -10px;
    color: #f00;
    font-size: 18px;
    line-height: 32px;
  }
</style>
